import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { Router, RouterModule } from '@angular/router';

import { Store } from '@ngrx/store';

import { selectIsAdmin } from '../../@store/user/user.selectors';
import { SafeAny } from '../../types/safe-any';

@Component({
  selector: 'ciwc-users',
  standalone: true,
  imports: [
    CommonModule,
    MatTableModule,
    MatTabsModule,
    MatButtonModule,
    MatPaginatorModule,
    MatSortModule,
    MatIconModule,
    MatDialogModule,
    MatCardModule,
    MatSelectModule,
    RouterModule,
  ],
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UsersComponent implements OnInit {
  private store = inject(Store);
  private readonly destroyRef = inject(DestroyRef);
  private readonly router = inject(Router);
  protected readonly Math = Math;
  readonly isAdmin = this.store.selectSignal(selectIsAdmin);

  currentTab = 0;

  ngOnInit(): void {
    this.currentTab = this.router.url.includes('active') ? 0 : 1;

    this.listenToRouteForTabChange();
  }

  onTabChange(index: number): void {
    this.currentTab = index;
    const route = index === 0 ? 'active' : 'archived';
    this.router.navigate(['/users', route]);
  }

  navigateToAddUser(): void {
    this.router.navigate(['/users/add']);
  }

  private listenToRouteForTabChange(): void {
    this.router.events.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((event: SafeAny) => {
      if (event.url === '/users/archived') {
        this.currentTab = 1;
      } else if (event.url === '/users/active') {
        this.currentTab = 0;
      }
    });
  }
}
